import { styled } from '@zoopla-eng/zds-components/themes';
import { Button, ButtonLeft } from '@zoopla-eng/zds-components/button';
import { Box } from '@zoopla-eng/zds-components/box';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';

export const StyledIntroText = styled('p', {
    display: 'block',
    color: '$textBody',
    fontGroup: 'ladle',
    paddingTop: '$S400',
    paddingBottom: '$S400'
});

export const StyledSignInButton = styled(ButtonLeft, {
    marginTop: '$S400',
    width: '100%'
});

export const StyledRegisterButton = styled(Button, {
    display: 'inline-block'
});

export const StyledRegisterContainer = styled(Box, {
    marginTop: '$M100',
    textAlign: 'center'
});

export const StyledSubtitle = styled(PageSubtitleShort, {
    fontGroup: 'whisk'
});
